import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {
  ApiConfig,
  Component,
  Footer,
  FullMenuSection,
  ImageConfig,
  KlaAllChartData,
  KlaAllEventsData,
  KlaAllNewsData,
  KlaChartData,
  KlaChartDataItem,
  KlaData,
  KlaEventsData,
  KlaNewsData,
  Package,
  Page,
  PageDetails,
  SubPackage
} from './kla.data.models';
import {Router} from '@angular/router';

// @ts-ignore
import * as kla from '../../../../config/kla.json';
// @ts-ignore
import * as kla2 from '../../../../config/kla2.json';
// @ts-ignore
import * as klaCharts from '../../../../config/kla.charts.json';
// @ts-ignore
import * as klaBlog from '../../../../config/kla.blog.json';
// @ts-ignore
import * as klaNews from '../../../../config/kla.news.json';
// @ts-ignore
import * as klaEvents from '../../../../config/kla.events.json';
// @ts-ignore
import {environment} from '../../../../environments/environment';
import {NewsConfigurations} from '../news/news.configurations';
import {EventConfigurations} from '../event/event.configurations';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {isPlatformServer} from '@angular/common';
import {DataService} from '../../services/data.service';

/**
 * Created by akifh on 04/03/2018.
 */

@Injectable({ providedIn: "root"})
export class KlaDataService {
  private data: KlaData;
  private livePreviewData: string;
  private IS_DATA_LOADED = new BehaviorSubject(false);
  public isDataLoaded = this.IS_DATA_LOADED.asObservable();
  public defaultData;

  livePreview = false;

  constructor(
    private router?: Router,
    @Inject(PLATFORM_ID) private platformId?: string
  ) {
    window.addEventListener('message', ($event) => {
      if ($event.origin != 'https://player.vimeo.com' && !$event.data.type) {
        this.getDataFromBackend($event);
        this.livePreview = true;
      }
      return Promise.resolve('Dummy response to avoid console error');
    });
  }


  fetchData() {
    return this.data;
  }

  public getData() {
    if (this.livePreview || this.data) {
      return this.data;
    }
    if (this.defaultData) {
      return this.defaultData;
    }

    let data = null;
    if (environment.json == 'kla') {
      data = <any>kla;
    } else {
      data = <any>kla2;
    }

    if (data && data.default && data.default.pages) {
      data.default.pages.forEach(page => {
        if (page && page.details && page.details.packages) {
          page.details.packages.forEach((pack, packIndex) => {
            if (!pack.fragment) {
              pack.fragment = 'p' + packIndex;
            }
            if (pack.subPackages) {
              pack.subPackages.forEach((subPack, subIndex) => {
                if (!subPack.fragment) {
                  subPack.fragment = 'sp' + packIndex + '' + subIndex;
                }
              });
            }
          });
        }
      });
    }
    if (data) {
      this.defaultData = data;
      this.IS_DATA_LOADED.next(true);
    }
    return data;
  }

  public getChartData(): KlaAllChartData {
    return <any>klaCharts;
  }

  public getBlogData(): any {
    return <any>klaBlog;
  }

  public getNewsData(): KlaAllNewsData {
    return <any>klaNews;
  }

  public getEventsData(): KlaAllEventsData {
    return <any>klaEvents;
  }

  public getChartConfig(chartName: string, id: string): any {
    const data = this.getChartData();
    let response = null;
    data.charts.forEach((chart: KlaChartData) => {
      if (chart.chartName == chartName) {
        chart.data.forEach((item: KlaChartDataItem) => {
          if (item.id == id) {
            response = item.config;
          }
        });
      }
    });
    return response;
  }

  public getBlogConfig(): Array<any> {
    return this.getBlogData();
  }

  public getNewsConfig(id: string): Array<NewsConfigurations> {
    const data = this.getNewsData();
    let response: Array<NewsConfigurations> = [];
    data.news.forEach((item: KlaNewsData) => {
      if (item.id == id) {
        response = item.config;
      }
    });
    return response;
  }

  public getEventsConfig(id: string): Array<EventConfigurations> {
    const data = this.getEventsData();
    let response: Array<EventConfigurations> = [];
    data.events.forEach((item: KlaEventsData) => {
      if (item.id == id) {
        response = item.config;
      }
    });
    return response;
  }

  public getPageData(layout: string): Page<PageDetails> {
    return this.getPage(layout);
  }

  public getImageConfig(): ImageConfig {
    let imageConfig: ImageConfig;

    try {
      if (this.livePreview || !DataService.getData().default) {
        imageConfig = DataService.getData().imageConfig;
      } else {
        imageConfig = DataService.getData().default.imageConfig;
      }
    } catch (error) {
      console.error('Could not load imageConfig from Data Service. \n', error);
    }

    return imageConfig;
  }

  public getApiConfig(): ApiConfig {
    if (this.livePreview || !DataService.getData().default) {
      return DataService.getData().apiConfig;
    }
    return DataService.getData().default.apiConfig;
  }

  public getPageSearchData(layout: string, query: string): Page<PageDetails> {
    const page: Page<PageDetails> = JSON.parse(JSON.stringify(this.getPage(layout)));
    if (query && query != '') {
      const oldPackages = page.details.packages;
      page.details.packages = [];
      oldPackages.forEach((pack: Package) => {
        const oldSubPackages = pack.subPackages;
        pack.subPackages = [];
        oldSubPackages.forEach((subPack: SubPackage) => {
          const oldComponents = subPack.components;
          subPack.components = [];
          oldComponents.forEach((component: Component) => {
            if (JSON.stringify(component).toLowerCase().indexOf(query.toLowerCase()) >= 0) {
              subPack.components.push(component);
            }
          });
          if (subPack.components.length > 0) {
            pack.subPackages.push(subPack);
          } else {
            if (JSON.stringify(subPack).toLowerCase().indexOf(query.toLowerCase()) >= 0) {
              pack.subPackages.push(subPack);
            }
          }
        });
        if (pack.subPackages.length > 0) {
          page.details.packages.push(pack);
          pack.packageDetails.active = true;
        } else {
          if (JSON.stringify(pack).toLowerCase().indexOf(query.toLowerCase()) >= 0) {
            page.details.packages.push(pack);
            pack.packageDetails.active = true;
          }
        }
      });
    }
    page.filter = query;
    return page;
  }

  public getPagesData(): Array<Page<any>> {
    let pages: Page<any>[] = [];

    try {
      if (this.livePreview || !DataService.getData().default) {
        pages = DataService.getData().pages;
      } else {
        pages = DataService.getData().default.pages;
      }
    } catch (error) {
      console.error('Could not load pages from Data Service. \n', error);
    }

    return pages;
  }

  public getMenuPages() {
    if (!DataService.getData().default) {
      return DataService.getData().fullMenuSections;
    }
    return DataService.getData().default.fullMenuSections;
  }

  public getFullMenuData(): Array<FullMenuSection> {
    const dashboard = this.getPageData('dashboard');
    const sections: Array<FullMenuSection> = [];
    const section: FullMenuSection = {
      subTitle: dashboard.name,
      components: []
    };
    dashboard.details.packages.forEach((pack: Package) => {
      const component = {
        image: pack.packageDetails.image,
        cropConfig: pack.packageDetails.cropConfig,
        title: pack.packageDetails.name,
        isVisible: pack.packageDetails.isVisible,
        lineColor: pack.packageDetails.color,
        description: pack.packageDetails.description,
        menuList: []
      };
      pack.subPackages.forEach((subPack: SubPackage) => {
        component.menuList.push({
          lineSize: 'line-small',
          text: subPack.link.title,
          link: subPack.link,
          routeFragment: subPack.fragment,
          isVisible: subPack.link.isVisible
        });
      });
      section.components.push(component);
    });
    sections.push(section);
    return sections;
  }

  public getCategories(): Array<any> {
    const data: any = this.data;
    if (typeof (data.meta) != 'undefined') {
      return data.meta.categories;
    } else { return null; }
  }

  public getFooterData(): Footer {
    if (!DataService.getData().default || this.livePreview) {
      return DataService.getData().footer;
    }
    return DataService.getData().default.footer;
  }

  public isPageEnabled(layout: string) {
    try {
      if (!DataService.getData().default || this.livePreview) {
        return DataService.getData().pages.find(x => x.layout == layout).isEnabled;
      }
      return DataService.getData().default ? DataService.getData().default.pages.find(x => x.layout == layout).isEnabled : DataService.getData().pages ? DataService.getData().pages.find(x => x.layout == layout).isEnabled : false;
    } catch (error) {
      console.error('There was an error while loading data from Data Service. ', error);
      return false;
    }
  }

  public getPage(layout: string): Page<any> {
    const pages = (isPlatformServer(this.platformId)) ? DataService.getData().pages : DataService.getData().default.pages;
    let found = null;
    if (pages) {
      pages.forEach((page: Page<any>) => {
        if (page.layout == layout) {
          found = page;
        }
      });
    }
    if (found == null) {
      if (this.livePreview || !DataService.getData().default) {
        return null;
      }
      this.router.navigate(['']);
      return <any>{ details: { packages: [] } };
    } else {
      return found;
    }
  }

  private getDataFromBackend(recived) {
    const site = recived.data;

    if (!site) {
      return;
    }

    let data: KlaData;
    let config: string;

    if (site && site.config && site.config.config) {
      config = site.config.config;
      data = JSON.parse(config);
    }
    if (site && site.fullConfig) {
      data = site.fullConfig;
    }

    if (this.livePreviewData) {
      const equal = this.livePreviewData === config;
      if (equal) {
        return;
      }
    }

    this.livePreviewData = config;
    if (data && data.pages) {
      data.pages.forEach(page => {
        if (page && page.details && page.details.packages) {
          page.details.packages.forEach((pack, packIndex) => {
            if (!pack.fragment) {
              pack.fragment = 'p' + packIndex;
            }
            if (pack.subPackages) {
              pack.subPackages.forEach((subPack, subIndex) => {
                if (!subPack.fragment) {
                  subPack.fragment = 'sp' + packIndex + '' + subIndex;
                }
              });
            }
          });
        }
      });
    }
    this.data = data;
  }
}
